import React, { useState, useEffect, Fragment } from "react";
import { Link } from 'react-router-dom';
import { Card, Form, Icon, Input, Button, Row, Checkbox, Col } from 'antd';
import { FaWhatsapp } from "react-icons/fa";
import { openNotificationWithIcon } from "../../common/Notification";
import TermsModal from "./components/TermsModal";
import { validForm } from "../../../functions/validForm";
import routes from "../../../const/routes";

function Login({props}){
    let [ voucher, setVoucher ] = useState({
        voucherCode: undefined,
        checked: false,
        statusVoucher: "",
    });
    let [ loading, setLoading ] = useState(false);
    let [ visible, setVisible ] = useState(false);
    let [ visiblePhone, setVisiblePhone ] = useState(false);
    let [ message, setMessage ] = useState(false);
    
    useEffect(() => {
        if(!props.voucher.loading && props.voucher.data && props.voucher.data.data && message){
            if(props.voucher.data.data.status === "wait"){
                openNotificationWithIcon('warning', "Aviso", props.voucher.data.data.message, "", 4);
            }else if(props.voucher.data.data.status === "success"){
                openNotificationWithIcon('success', "Sucesso", props.voucher.data.data.message, "", 4);
                localStorage.setItem('@Ossel:voucher', props.voucher.data.data.result[0].voucher);
                localStorage.setItem('@Ossel:room', props.voucher.data.data.result[0].room[0]);
                setTimeout(() => {
                    setVoucher(voucher = {
                        voucherCode: undefined,
                        checked: false,
                        statusVoucher: "",
                    })
                    props.history.push(routes.ROOM_LIVE)
                    setLoading(loading = false);
                },2000)
            }else if(props.voucher.data.data.status === "finish"){
                openNotificationWithIcon('warning', "Finalizado", props.voucher.data.data.message, "", 4);
            }else if(props.voucher.data.data.status === "error"){
                openNotificationWithIcon('error', "Voucher", props.voucher.data.data.message, "", 4);
            }

            setMessage(message = false)
        }
    }, [props.voucher])

    function updateVoucher(e){
        if(e.target.value === ""){
            setVoucher(voucher = {...voucher, 
                voucherCode: e.target.value,
                statusVoucher: "error"
            })
        }else{
            setVoucher(voucher = {...voucher, 
                voucherCode: e.target.value,
                statusVoucher: "success"
            })
        }
    }

    function checkVoucher(){

        if(!validForm(voucher)){
            openNotificationWithIcon(
                'warning',"Aviso", 
                "Preencha o voucher para continuar.",
                "",5
            );
            return 
        }

        if(!voucher.checked){
            openNotificationWithIcon(
                'warning',"Aviso", 
                "Concorde com os termos e condições para continuar.",
                "",5
            );
            return 
        }

        setLoading(loading = true);

        setTimeout(() => {
            setLoading(loading = false);
        }, 2000)

        const data = {
            voucher: voucher.voucherCode
        };
        props.CHECK_VOUCHER(data);
        setMessage(message = true)
    }

    return(
        <header className="v-header container">
            <div className="fullscreen-video-wrap">
                <img alt="" style={{width: "100%"}} src={require("../../../img/background.jpg")}/>
            </div>
            <div className="header-overlay"></div>
            <div className="App-header">
                <Card 
                    style={{ width: 400, height: 410, borderRadius: 45 }}
                    cover={
                        <img 
                            alt="Logo"
                            src={require("../../../img/logoAssistencia.png")} 
                            style={{ 
                                borderRadius: "20px", 
                                marginTop: 30, 
                                width: "90%", 
                                display: "block", 
                                marginLeft: "auto", 
                                marginRight: "auto"
                            }}  
                        />
                    }
                    className="cardLogin"
                >
                    <TermsModal  visible={visible} setVisible={setVisible}/>

                    {
                        visiblePhone ?
                            <Fragment>
                                <div style={{ alignContent: "center", textAlign: "center", fontSize: 29 }}>
                                    <p style={{ color: "#053567" }}><Icon type="phone" style={{ color: "#053567" }}/> <strong>(15) 3232-6998</strong></p>
                                    <p style={{ color: "#053567" }}><FaWhatsapp style={{ color: "#053567", marginTop:5 }}/> <strong>(15) 99803-2893 </strong></p>
                                </div>

                                <Row>
                                    <Button 
                                        style={{width: "100%", marginTop: 10}}
                                        loading={loading} 
                                        onClick={() => setVisiblePhone(false)} 
                                        type="primary" 
                                    >
                                        Voltar
                                    </Button>
                                </Row>
                            </Fragment>
                        : 
                            <Fragment>
                                <Form 
                                    //onSubmit={login} 
                                    className="login-form"
                                    style={{marginTop: 20}}
                                >
                                    <Form.Item
                                        validateStatus={voucher.statusVoucher}
                                        //help={user.messageUser}
                                        hasFeedback
                                    >
                                        <Input 
                                            onChange={(e) => updateVoucher(e)} 
                                            prefix={<Icon type="file-done" style={{ color: 'rgba(0,0,0,.25)' }} />} 
                                            placeholder="Voucher" 
                                        />
                                    </Form.Item>
                                </Form>

                                <Form.Item
                                    style={{marginTop: -25}}
                                >
                                    <Row>
                                        <Col xs={24} sm={16} md={16} lg={16} xl={16}>   
                                            <Checkbox
                                                checked={voucher.checked}
                                                onClick={() => setVoucher(voucher = {...voucher, checked: !voucher.checked})}
                                            >
                                                Eu concordo com os
                                                <Button 
                                                    type="link"
                                                    onClick={() => setVisible(visible = true)}
                                                    style={{marginLeft: -8}}
                                                >termos</Button>
                                            </Checkbox>
                                        </Col>
                                        <Col xs={24} sm={8} md={8} lg={8} xl={8}>   
                                            <Button 
                                                type="link"
                                                onClick={() => setVisiblePhone(true)}
                                                style={{marginLeft: -8}}
                                            >
                                                <strong style={{ color: "#053567", alignContent: "right", textAlign: "right", alignItems: "right" }}>
                                                    <Icon type="customer-service" style={{ color: 'rgba(0,0,0,.50)', marginRight: 5, fontSize: 15, marginLeft: 15 }} />CONTATO
                                                </strong>
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form.Item>

                                <Form.Item
                                    style={{marginTop: 40}}
                                >
                                    <Row>
                                        <Button 
                                            style={{width: "100%"}}
                                            loading={loading} 
                                            onClick={() => checkVoucher()} 
                                            type="primary" 
                                        >
                                            Continuar
                                        </Button>
                                    </Row>
                                    <Row>
                                        <Link to={routes.LOGIN}>
                                            <Button 
                                                type="link"
                                                style={{marginLeft: "40%"}}
                                            >Login</Button>
                                        </Link>
                                    </Row>
                                </Form.Item> 
                            </Fragment>
                    }
                    
                </Card>   
            </div>
        </header>
    )
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/general/voucherWrapper/Voucher.jsx